import { SecureAction } from '../secure-actions';

export class ModelSecureAction extends SecureAction {
  public static readonly EDIT: SecureAction = new ModelSecureAction('settings:redirecturl|edit');
  private constructor(name: string) {
    super(name);
  }
}
